import { render, staticRenderFns } from "./UpdateBudget.vue?vue&type=template&id=fd6ce0a0"
import script from "./UpdateBudget.vue?vue&type=script&lang=js"
export * from "./UpdateBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports